import _ from 'lodash';
import EventEmitter from '../../../../utility/event-emitter';
const INTERVAL = 1000; //once a sec
const getBytesSentFromStats = (stats) => {
    return _.get(stats, 'audio.bytesSent', 0);
};
export default class TokboxPublisherListener extends EventEmitter {
    constructor($injector, publisher) {
        super();
        this.$injector = $injector;
        this.publisher = publisher;
        const $log = this.$injector.get('$log');
        this.debug = $log.debug.bind($log, 'TokboxPublisherListener');
        this.trackStats();
        this.checkNoAudio();
    }
    trackStats() {
        let previousStats = null;
        const interval = setInterval(() => {
            this.publisher.getStats((err, data) => {
                if (err) {
                    return;
                }
                const currentStats = _.get(data, '[0].stats');
                if (!previousStats) {
                    previousStats = currentStats;
                    return;
                }
                const stats = {
                    audioBitrate: this.getAudioBitrate(previousStats, currentStats),
                };
                this.emit('stats', stats);
                this.debug('stats', stats);
                previousStats = currentStats;
            });
        }, INTERVAL);
        this.publisher.on('destroyed', () => {
            this.debug('publisher destroyed');
            clearInterval(interval);
        });
    }
    getAudioBitrate(previousStats, currentStats) {
        const previousBytesSent = getBytesSentFromStats(previousStats);
        const currentBytesSent = getBytesSentFromStats(currentStats);
        const bitrate = (currentBytesSent - previousBytesSent) / 1024; //kbs
        return bitrate;
    }
    checkNoAudio() {
        const notifyAboutNoAudio = (stats) => {
            if (stats.audioBitrate === 0) {
                this.emit('noSoundDetected');
                this.debug('noSoundDetected');
                this.off('stats', notifyAboutNoAudio);
            }
        };
        this.on('stats', notifyAboutNoAudio);
    }
}
